module.exports = __webpack_public_path__ + "static/media/I_surrender_to_the_hypno_virus.99f31c6d.mp3";